const featuresData = [
  {
    id: 1,
    title: "Smart Packing",
    description:
      "Never forget the essentials. AI builds a personalized packing list based on your destination, weather, and trip type.",
    imgSrc: "./Images/Checklist.svg",
    imgAlt: "Smart Packing Icon",
    backgroundColor: "rgb(249, 168, 110)",
  },
  {
    id: 2,
    title: "Daily Trip Insights",
    description:
      "Get daily AI-powered tips tailored to your trip so you experience more, stress less, and stay one step ahead.",
    imgSrc: "./Images/lightbulb.svg",
    imgAlt: "Daily Trip Insights Icon",
    backgroundColor: "#42C4DE",
  },
  {
    id: 3,
    title: "Budget & Settlements",
    description:
      "Track all expenses, split group costs fairly, and settle balances instantly so money never slows the trip down.",
    imgSrc: "./Images/budget-tracker-icon.svg",
    imgAlt: "Budget and Settlements Icon",
    backgroundColor: "#83D8AD",
  },
  {
    id: 4,
    title: "Travel Journal & Timeline",
    description:
      "Capture moments with guided prompts, photos, mood tracking, and ratings while your memories automatically organize to relive every adventure.",
    imgSrc: "./Images/journal-icon.svg",
    imgAlt: "Trip Journal Icon",
    backgroundColor: "#DC9BFA",
  },
  {
    id: 5,
    title: "Translator & Key Phrases",
    description:
      "Speak the language instantly. Translate text or learn essential phrases tailored to where you are.",
    imgSrc: "./Images/translator-icon.svg",
    imgAlt: "Translator and Phrases Icon",
    backgroundColor: "#DE4255",
  },
  {
    id: 6,
    title: "Exchange Rates",
    description:
      "Know what you're really spending with live exchange rates and instant currency conversions.",
    imgSrc: "./Images/currency-icon.svg",
    imgAlt: "Exchange Rates Icon",
    backgroundColor: "#83D8AD",
  },
  {
    id: 7,
    title: "Travel Trivia & Discoveries",
    description:
      "Discover fun facts, hidden stories, and cultural insights about every place you visit.",
    imgSrc: "./Images/earth.png",
    imgAlt: "Travel Trivia Icon",
    backgroundColor: "#42C4DE",
  },
  {
    id: 8,
    title: "Playbooks & Itineraries",
    description:
      "Explore curated travel playbooks, custom itineraries, and destination tools built for real travelers.",
    imgSrc: "./Images/builder-icon.svg",
    imgAlt: "Playbooks and Itineraries Icon",
    backgroundColor: "#5BAD72",
  },
];

export default featuresData;
